/** The closed vocabulary of semantic animation state names (corpus-derived).
 * Owned here, the lowest package that needs it: composed gameplay modules
 * declare which of these they put on an entity, and `@djgg/creations`
 * re-exports the same list for manifests, strips and the art plan. */
export const ANIM_STATE_NAMES = [
  'idle',
  'move',
  'jump',
  'climb',
  'hang',
  'crouch',
  'dash',
  'shoot',
  'action-1',
  'action-2',
  'action-3',
  'action-4',
  'hit',
  'down',
  'win',
] as const;

/** One member of {@link ANIM_STATE_NAMES}. */
export type AnimStateName = (typeof ANIM_STATE_NAMES)[number];
